"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _difference2 = _interopRequireDefault(require("lodash/difference"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _DropdownList = _interopRequireDefault(require("react-widgets/lib/DropdownList"));
var _Multiselect = _interopRequireDefault(require("react-widgets/lib/Multiselect"));
var _arrowDown = _interopRequireDefault(require("cccisd-icons/arrow-down5"));
var _bin = _interopRequireDefault(require("cccisd-icons/bin"));
var _info = _interopRequireDefault(require("cccisd-icons/info2"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _cccisdWysiwyg = _interopRequireDefault(require("cccisd-wysiwyg"));
var _InfoLabel = _interopRequireDefault(require("../../../../components/InfoLabel"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var ActionCondition = function ActionCondition(_ref) {
  var conditionConfig = _ref.conditionConfig,
    conditionKeyFrequencies = _ref.conditionKeyFrequencies,
    conditions = _ref.conditions,
    currentRoleDcws = _ref.currentRoleDcws,
    deleteCondition = _ref.deleteCondition,
    errors = _ref.errors,
    fields = _ref.fields,
    isReorderingBranches = _ref.isReorderingBranches,
    updateConditionConfig = _ref.updateConditionConfig;
  var _useState = (0, _react.useState)(true),
    _useState2 = _slicedToArray(_useState, 2),
    firstLoad = _useState2[0],
    setFirstLoad = _useState2[1];
  var _useState3 = (0, _react.useState)(conditionConfig.action || 'message'),
    _useState4 = _slicedToArray(_useState3, 2),
    action = _useState4[0],
    setAction = _useState4[1];
  var _useState5 = (0, _react.useState)(conditionConfig.addToDcws || []),
    _useState6 = _slicedToArray(_useState5, 2),
    addToDcws = _useState6[0],
    setAddToDcws = _useState6[1];
  var _useState7 = (0, _react.useState)(conditionConfig.completionDcw || undefined),
    _useState8 = _slicedToArray(_useState7, 2),
    completionDcw = _useState8[0],
    setCompletionDcw = _useState8[1];
  var _useState9 = (0, _react.useState)(conditionConfig.completionMessage || 'You have completed the survey! Thank you for your response!'),
    _useState0 = _slicedToArray(_useState9, 2),
    completionMessage = _useState0[0],
    setCompletionMessage = _useState0[1];
  var _useState1 = (0, _react.useState)(conditionConfig.completionUrl || ''),
    _useState10 = _slicedToArray(_useState1, 2),
    completionUrl = _useState10[0],
    setCompletionUrl = _useState10[1];
  var _useState11 = (0, _react.useState)(conditionConfig.conditionName || ''),
    _useState12 = _slicedToArray(_useState11, 2),
    conditionName = _useState12[0],
    setConditionName = _useState12[1];
  var _useState13 = (0, _react.useState)(conditionConfig.conditionTarget || ''),
    _useState14 = _slicedToArray(_useState13, 2),
    conditionTarget = _useState14[0],
    setConditionTarget = _useState14[1];
  var _useState15 = (0, _react.useState)(true),
    _useState16 = _slicedToArray(_useState15, 2),
    isConditionExpanded = _useState16[0],
    setIsConditionExpanded = _useState16[1];
  var _useState17 = (0, _react.useState)(conditionConfig.showReviewButtonOnCompletion || false),
    _useState18 = _slicedToArray(_useState17, 2),
    showReviewButtonOnCompletion = _useState18[0],
    setShowReviewButtonOnCompletion = _useState18[1];
  var _useState19 = (0, _react.useState)(conditionConfig.logoutOnCompletion || false),
    _useState20 = _slicedToArray(_useState19, 2),
    logoutOnCompletion = _useState20[0],
    setLogoutOnCompletion = _useState20[1];

  /* /////////////////////////////////////////////////////////////////////////
  // LIFECYCLE METHODS //////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  (0, _react.useEffect)(function () {
    if (!firstLoad) {
      var actionToSet = conditionConfig.action || 'message';
      var completionMessageToSet = conditionConfig.completionMessage || 'You have completed the survey! Thank you for your response!';
      setAction(actionToSet);
      setAddToDcws(conditionConfig.addToDcws || []);
      setCompletionDcw(conditionConfig.completionDcw || undefined);
      setCompletionUrl(conditionConfig.completionUrl || '');
      setConditionName(conditionConfig.conditionName || '');
      setConditionTarget(conditionConfig.conditionTarget || '');
      setLogoutOnCompletion(conditionConfig.logoutOnCompletion || false);
      setShowReviewButtonOnCompletion(conditionConfig.showReviewButtonOnCompletion || false);
      if (actionToSet === 'message' && !conditionConfig.completionMessage) {
        changeField({
          target: {
            name: 'completionMessage',
            value: completionMessageToSet
          }
        }, setCompletionMessage);
      } else {
        if (!conditionConfig.action) {
          changeField({
            target: {
              name: 'action',
              value: actionToSet
            }
          }, setAction);
        }
        setCompletionMessage(completionMessageToSet);
      }
    } else {
      setFirstLoad(false);
    }
  }, [conditionConfig]);
  (0, _react.useEffect)(function () {
    if (!isConditionExpanded && errors) {
      setIsConditionExpanded(true);
    }
  }, [errors]);
  (0, _react.useEffect)(function () {
    if (!isConditionExpanded && conditions.length === 1) {
      setIsConditionExpanded(true);
    }
  }, [conditions]);

  /* /////////////////////////////////////////////////////////////////////////
  // GENERAL FUNCTIONS //////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  function changeField(event, customSet) {
    var updatedConfig = _objectSpread({}, conditionConfig);
    updatedConfig[event.target.name] = event.target.value;
    updateConditionConfig(updatedConfig);
    customSet(event.target.value);
  }

  /* /////////////////////////////////////////////////////////////////////////
  // RENDER-RELATED /////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  function renderActualFrequency() {
    var keysInBranch = conditions.map(function (c) {
      return Number(c.key);
    });
    var total = conditionKeyFrequencies.reduce(function (acc, f) {
      return f.value && keysInBranch.includes(Number(f.value)) ? acc + f.valueCount : acc;
    }, 0);
    var thisKeyFrequency = conditionKeyFrequencies.find(function (f) {
      return Number(f.value) === Number(conditionConfig.key);
    });
    var thisFrequency = thisKeyFrequency ? Number(thisKeyFrequency.valueCount) : 0;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].formulaPart,
      style: {
        maxWidth: '15rem'
      }
    }, /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
      label: "Actual Share",
      tooltip: "Within this branch only. ".concat(thisFrequency, " / ").concat(total)
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].actualShareNumber
    }, total ? Math.round(thisFrequency / total * 1000.0) / 10.0 : 0, "%"));
  }
  function renderActionField() {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: "form-check"
    }, /*#__PURE__*/_react["default"].createElement("label", {
      className: "form-check-label"
    }, /*#__PURE__*/_react["default"].createElement("input", {
      className: "form-check-input",
      type: "radio",
      checked: action === 'message',
      onChange: function onChange() {
        changeField({
          target: {
            name: 'action',
            value: 'message'
          }
        }, setAction);
      }
    }), ' ', "Show completion message")), /*#__PURE__*/_react["default"].createElement("div", {
      className: "form-check"
    }, /*#__PURE__*/_react["default"].createElement("label", {
      className: "form-check-label"
    }, /*#__PURE__*/_react["default"].createElement("input", {
      className: "form-check-input",
      type: "radio",
      checked: action === 'url',
      onChange: function onChange() {
        return changeField({
          target: {
            name: 'action',
            value: 'url'
          }
        }, setAction);
      }
    }), ' ', "Go to URL")), /*#__PURE__*/_react["default"].createElement("div", {
      className: "form-check"
    }, /*#__PURE__*/_react["default"].createElement("label", {
      className: "form-check-label"
    }, /*#__PURE__*/_react["default"].createElement("input", {
      className: "form-check-input",
      type: "radio",
      checked: action === 'dcwRedirect',
      onChange: function onChange() {
        return changeField({
          target: {
            name: 'action',
            value: 'dcwRedirect'
          }
        }, setAction);
      }
    }), ' ', "Go to Data Collection Wave")));
  }
  function renderAddToDcwsMultiselect() {
    var addToDcwData = currentRoleDcws.filter(function (d) {
      return d.type === 'known' || !['known', 'anon'].includes(d.type) && d.settings.closedRoster;
    });
    var invalidAddToDcws = (0, _difference2["default"])(addToDcws, addToDcwData.map(function (d) {
      return d.deploymentId;
    }));
    if (invalidAddToDcws.length) {
      setAddToDcws((0, _difference2["default"])(addToDcws, invalidAddToDcws));
      return null;
    }
    var hasError = (0, _get2["default"])(errors, 'addToDcws');
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('mt-3', hasError ? 'is-invalid' : '')
    }, /*#__PURE__*/_react["default"].createElement("label", {
      className: "form-label"
    }, /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
      label: "Also add to Data Collection Waves(s)",
      tooltip: "Once they finish the Quest, add the respondent to the selected Data Collection Wave(s)."
    })), /*#__PURE__*/_react["default"].createElement(_Multiselect["default"], {
      data: addToDcwData,
      filter: "contains",
      groupBy: function groupBy(item) {
        return item && item.assignment.label || '';
      },
      itemComponent: function itemComponent(_ref2) {
        var item = _ref2.item;
        return item && item.label || '';
      },
      onChange: function onChange(e) {
        return changeField({
          target: {
            name: 'addToDcws',
            value: e.map(function (d) {
              return d.deploymentId;
            })
          }
        }, setAddToDcws);
      },
      placeholder: "--- Choose a Data Collection Wave ---",
      textField: function textField(item) {
        return item && "".concat(item.label, " (").concat(item.assignment.label, ")") || '';
      },
      value: addToDcws,
      valueField: "deploymentId"
    }), hasError && /*#__PURE__*/_react["default"].createElement("div", {
      className: "text-danger"
    }, hasError));
  }
  var renderCollapseArrow = /*#__PURE__*/_react["default"].createElement("div", {
    onClick: function onClick() {
      return setIsConditionExpanded(!isConditionExpanded);
    },
    className: (0, _classnames["default"])(_style["default"].collapseArrow, isConditionExpanded ? _style["default"].expanded : _style["default"].collapsed)
  }, /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], null));
  function renderCompletionDcwDropdown() {
    if (action !== 'dcwRedirect') {
      return null;
    }
    if (completionDcw && !currentRoleDcws.map(function (d) {
      return d.deploymentId;
    }).includes(completionDcw)) {
      setCompletionDcw(undefined);
      return null;
    }
    var hasError = (0, _get2["default"])(errors, 'completionDcw');
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: hasError ? 'is-invalid' : ''
    }, /*#__PURE__*/_react["default"].createElement("label", {
      className: "form-label"
    }, /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
      label: "Completion DCW",
      tooltip: "A Data Collection Wave to send the respondent to once they finish the Quest."
    })), /*#__PURE__*/_react["default"].createElement(_DropdownList["default"], {
      data: currentRoleDcws,
      groupBy: function groupBy(item) {
        return item && item.assignment.label;
      },
      onChange: function onChange(e) {
        return changeField({
          target: {
            name: 'completionDcw',
            value: e.deploymentId
          }
        }, setCompletionDcw);
      },
      placeholder: "--- Choose a Data Collection Wave ---",
      textField: "label",
      value: completionDcw,
      valueComponent: function valueComponent(_ref3) {
        var item = _ref3.item;
        return item && "".concat(item.label, " (").concat(item.assignment.label, ")") || completionDcw;
      },
      valueField: "deploymentId"
    }), hasError && /*#__PURE__*/_react["default"].createElement("div", {
      className: "text-danger"
    }, hasError));
  }
  function renderCompletionMessage() {
    if (action !== 'message') {
      return null;
    }
    var hasError = (0, _get2["default"])(errors, 'completionMessage');
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('mt-3', hasError && 'is-invalid')
    }, /*#__PURE__*/_react["default"].createElement("label", {
      className: "form-label"
    }, /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
      label: "Completion message",
      tooltip: "Message to show respondents when they finish the Quest."
    })), isReorderingBranches && /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        height: '100px'
      }
    }), !isReorderingBranches && /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg["default"], {
      content: completionMessage,
      inputStyle: {
        minHeight: '100px'
      },
      onChange: function onChange(value) {
        return changeField({
          target: {
            name: 'completionMessage',
            value: value
          }
        }, setCompletionMessage);
      }
    }), hasError && /*#__PURE__*/_react["default"].createElement("div", {
      className: "text-danger"
    }, hasError));
  }
  function renderCompletionUrl() {
    if (action !== 'url') {
      return null;
    }
    var hasError = (0, _get2["default"])(errors, 'completionUrl');
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: hasError ? 'is-invalid' : ''
    }, /*#__PURE__*/_react["default"].createElement("label", {
      className: "form-label"
    }, /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
      label: "Completion URL",
      tooltip: "A URL to send the respondent once they finish the Quest. (Must include protocol. E.g., 'https://www.google.com' instead of 'www.google.com')"
    })), /*#__PURE__*/_react["default"].createElement("input", {
      className: "form-control",
      name: "completionUrl",
      onChange: function onChange(e) {
        return changeField(e, setCompletionUrl);
      },
      type: "text",
      value: completionUrl
    }), hasError && /*#__PURE__*/_react["default"].createElement("div", {
      className: "text-danger"
    }, hasError));
  }
  function renderConditionName() {
    if (!isConditionExpanded) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])(_style["default"].indentedLabel, _style["default"].collapsedLabel)
      }, /*#__PURE__*/_react["default"].createElement("strong", null, "Condition Name:"), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].collapsedField
      }, conditionName));
    }
    var hasError = (0, _get2["default"])(errors, 'conditionName');
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])(_style["default"].flexExpand, hasError ? 'is-invalid' : '')
    }, /*#__PURE__*/_react["default"].createElement("label", {
      className: "form-label ".concat(_style["default"].indentedLabel)
    }, "Condition Name"), /*#__PURE__*/_react["default"].createElement("input", {
      className: "form-control",
      name: "conditionName",
      onChange: function onChange(e) {
        return changeField(e, setConditionName);
      },
      type: "text",
      value: conditionName
    }), hasError && /*#__PURE__*/_react["default"].createElement("div", {
      className: "text-danger"
    }, hasError));
  }
  var renderConditionDeleteButton = /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
    title: "Delete Condition"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: (0, _classnames["default"])('btn btn-sm btn-danger', _style["default"].deleteButton, _style["default"].deleteConditionButtonTop),
    onClick: deleteCondition,
    type: "button"
  }, /*#__PURE__*/_react["default"].createElement(_bin["default"], null)));
  var renderConditionFields = /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].branchNameWrapper
  }, renderCollapseArrow, renderConditionName(), isConditionExpanded && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, renderConditionTarget(), renderActualFrequency(), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].flexRight
  }, renderConditionDeleteButton))));
  function renderConditionTarget() {
    var hasError = (0, _get2["default"])(errors, 'conditionTarget');
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('mb-3', hasError ? 'is-invalid' : '', _style["default"].formulaPart),
      style: {
        maxWidth: '23rem'
      }
    }, /*#__PURE__*/_react["default"].createElement("label", {
      className: "form-label"
    }, "Target Share of Respondents"), /*#__PURE__*/_react["default"].createElement("div", {
      className: "input-group"
    }, /*#__PURE__*/_react["default"].createElement("input", {
      className: "form-control",
      name: "conditionTarget",
      onChange: function onChange(e) {
        return changeField(e, setConditionTarget);
      },
      type: "number",
      value: conditionTarget
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "input-group-text"
    }, "%")), hasError && /*#__PURE__*/_react["default"].createElement("div", {
      className: "text-danger"
    }, hasError));
  }
  var renderLogoutOnCompletion = fields.respondentConfig.value === 'managed' && fields.requireLogin.value && /*#__PURE__*/_react["default"].createElement("div", {
    className: "checkbox ".concat(_style["default"].marginTop)
  }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", {
    type: "checkbox",
    checked: logoutOnCompletion,
    onChange: function onChange(e) {
      return changeField({
        target: {
          name: 'logoutOnCompletion',
          value: !logoutOnCompletion
        }
      }, setLogoutOnCompletion);
    }
  }), "Logout on Completion"));
  function renderShowReviewButtonOnCompletion() {
    if (action !== 'message' || !fields.allowRetake.value || logoutOnCompletion) {
      return null;
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "checkbox ".concat(_style["default"].marginTop)
    }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", {
      type: "checkbox",
      checked: showReviewButtonOnCompletion,
      onChange: function onChange() {
        return changeField({
          target: {
            name: 'showReviewButtonOnCompletion',
            value: !showReviewButtonOnCompletion
          }
        }, setShowReviewButtonOnCompletion);
      }
    }), "Show Review Button", ' ', /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
      title: "Show button to return respondent to beginning of the Quest."
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "text-primary"
    }, /*#__PURE__*/_react["default"].createElement(_info["default"], null)))));
  }

  /* /////////////////////////////////////////////////////////////////////////
  // RENDER /////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].actionWrapper
  }, conditions.length >= 2 && renderConditionFields, isConditionExpanded && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, renderActionField(), renderLogoutOnCompletion, renderShowReviewButtonOnCompletion(), renderCompletionDcwDropdown(), renderCompletionMessage(), renderCompletionUrl(), renderAddToDcwsMultiselect()));
};
ActionCondition.propTypes = {
  conditionConfig: _propTypes["default"].object,
  conditionKeyFrequencies: _propTypes["default"].array,
  conditions: _propTypes["default"].array,
  currentRoleDcws: _propTypes["default"].array,
  deleteCondition: _propTypes["default"].func,
  deploymentId: _propTypes["default"].number,
  errors: _propTypes["default"].object,
  fields: _propTypes["default"].object,
  isReorderingBranches: _propTypes["default"].bool,
  updateConditionConfig: _propTypes["default"].func
};
var _default = exports["default"] = ActionCondition;